import { r as reinitializeSwipers } from "./utilities-swiper-element.js";
import { a as addToCartFromCard } from "./section-main-cart.js";
import { r as reanimateImages, b as reTrapFocusAfterUpdate } from "./utilities-utils.js";
import "./vendors.js";
import "./swiper-modules.js";
import "./utilities-nav-utils.js";
document.addEventListener("DOMContentLoaded", function() {
  const drawer = document.querySelector('drawer-component[data-drawer="quick-view"]');
  const drawerContent = drawer?.querySelector(".quick-view__product");
  const viewFullDetailsLink = drawer?.querySelector("a.drawer__close");
  if (!drawer) {
    console.error("Quick view drawer component not found.");
    return;
  }
  const preloadCache = /* @__PURE__ */ new Map();
  document.body.addEventListener("mouseenter", function(e) {
    const btn = e.target.closest('button[data-drawer="quick-view"]');
    if (!btn) return;
    const productUrl = btn.getAttribute("data-product");
    if (!productUrl || preloadCache.has(productUrl)) return;
    preloadCache.set(productUrl, "loading");
    const targetPageUrl = new URL(productUrl, window.location.origin);
    fetch(targetPageUrl.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } }).then((res) => res.ok ? res.text() : Promise.reject(`Network error: ${res.status}`)).then((htmlText) => {
      preloadCache.set(productUrl, htmlText);
    }).catch((err) => {
      console.log("Preload failed (not critical):", err);
      preloadCache.delete(productUrl);
    });
  }, true);
  document.body.addEventListener("click", async function(e) {
    const btn = e.target.closest('button[data-drawer="quick-view"]');
    if (!btn) return;
    const productUrl = btn.getAttribute("data-product");
    if (!productUrl || !drawerContent) {
      console.error("Quick view button is missing product URL or drawer content area is not found.");
      return;
    }
    if (typeof drawer.open === "function") {
      drawer.open();
    } else {
      console.error("Quick view drawer does not have an open method. Cannot trigger overlay.");
    }
    drawerContent.innerHTML = '<div class="quick-view__loading"><svg width="24px" height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" r="40" stroke-dasharray="163.36281798666926 87.9645943005142" stroke="currentColor" fill="none" stroke-width="8"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.4;1" dur="0.8s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg></div>';
    try {
      let htmlText;
      if (preloadCache.has(productUrl) && preloadCache.get(productUrl) !== "loading") {
        htmlText = preloadCache.get(productUrl);
      } else {
        const targetPageUrl = new URL(productUrl, window.location.origin);
        const fetchUrlString = targetPageUrl.toString();
        const res = await fetch(fetchUrlString, { headers: { "X-Requested-With": "XMLHttpRequest" } });
        if (!res.ok) throw new Error(`Network error: ${res.status} ${res.statusText}`);
        htmlText = await res.text();
        preloadCache.set(productUrl, htmlText);
      }
      const tempParser = document.createElement("div");
      tempParser.innerHTML = htmlText;
      const mainProductSection = tempParser.querySelector(".main-product");
      if (mainProductSection) {
        const clonedContent = mainProductSection.cloneNode(true);
        const elementsToRemove = clonedContent.querySelectorAll(
          ".pdp-lightbox, .usp-product--availability, .usp-product, drawer-component, .quick-view-hide"
        );
        elementsToRemove.forEach((element) => element.remove());
        drawerContent.innerHTML = clonedContent.innerHTML;
        if (viewFullDetailsLink) {
          const targetPageUrl = new URL(productUrl, window.location.origin);
          viewFullDetailsLink.setAttribute("href", targetPageUrl.toString());
        }
        reinitializeSwipers();
        addToCartFromCard();
        reanimateImages(drawerContent);
        reTrapFocusAfterUpdate({
          drawer,
          root: drawer,
          selector: 'button, input, select, textarea, a[href], [tabindex]:not([tabindex^="-"])',
          delay: 500
        });
      } else {
        console.error("Section with class .main-product not found on page:", productUrl);
        drawerContent.innerHTML = '<div class="quick-view__error">Failed to load product content. Please try again.</div>';
      }
    } catch (err) {
      console.error("Quick view fetch error:", err);
      drawerContent.innerHTML = '<div class="quick-view__error">Failed to load product. Please try again.</div>';
    }
  });
});
